












import { Component, Prop, Vue } from 'vue-property-decorator';

import CounterComponent from '@/shared/components/counter/Counter.component.vue';
import { CounterInterface } from '@/shared/components/counter/counter.interface.ts';

@Component({
  components: {
    CounterComponent,
  },
})
export default class GroupFilter extends Vue {
  @Prop() private counters!: CounterInterface[];
  @Prop({ default: true }) private enabled!: boolean;

  private counterClicked(counter: CounterInterface) {
    if ( this.enabled ) {
      this.$emit('option-selected', counter);
    }
  }
}
